<script lang="ts" setup>
import AppFooter from '~/app/components/Layout/AppFooter.vue'
import AppHeader from '~/app/components/Layout/AppHeader.vue'

const route = useRoute()

const ui = computed(() => {
  const mainWidth
    = route.meta.layoutContainer === 'full'
      ? 'max-w-full'
      : 'max-w-(--ui-container)'

  return {
    main: mainWidth + 'm-auto w-full',
  }
})
</script>

<template lang="html">
  <div class="default-layout flex h-full min-h-full flex-col">
    <AppHeader />

    <main :class="[ui.main, 'flex-1']">
      <slot />
    </main>

    <AppFooter />
  </div>
</template>
